@import '~style-sheet-helpers/core.less';

.adjust-weight {
  width: 100%;
}

.weight-options {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;

  > * {
    margin-right: 10px;
  }
}

.weight-input {
  width: 100%;
  > * {
    width: 100%;
  }
}
